import React, {useEffect} from 'react';
import {BiArrowBack} from 'react-icons/bi';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {usePost} from '../../data/resources';
import {newsArticleLd, truncate} from '../../seo/meta';
import {usePageMeta} from '../../seo/usePageMeta';
import {formatDate} from '../../utils/date';
import {articleIdFromSlug, articlePath} from '../../utils/slug';
import {NotFoundContent} from '../notfound/NotFound';
import './articleview.css';

const ArticleView = () => {
    const {slug = ''} = useParams();
    const id = articleIdFromSlug(slug);
    const navigate = useNavigate();
    const {pathname} = useLocation();
    const {data: article, error} = usePost(id ?? '0');
    const path = article && articlePath(article);
    const notFound = !id || (error && !article);

    // short or outdated addresses ("/news/1179") are replaced by the full one
    useEffect(() => {
        if (path && pathname !== path) navigate(path, {replace: true});
    }, [path, pathname, navigate]);

    usePageMeta(article && path ? {
        title: article.title,
        description: truncate(article.excerpt),
        image: article.imageUrl,
        type: 'article',
        path,
        jsonLd: newsArticleLd({...article, path}),
    } : notFound ? {title: 'Artikel nicht gefunden', noindex: true} : {title: 'News'});

    // opened via a shared link there is no page of ours to go back to
    const goBack = () => ((window.history.state?.idx ?? 0) > 0 ? navigate(-1) : navigate('/news'));

    if (notFound) return <NotFoundContent/>;

    return (
        <div className="page page--narrow">
            <button type="button" onClick={goBack} className="back-link">
                <BiArrowBack aria-hidden="true"/> Zurück
            </button>
            <article className="card content-card">
                {article ? (
                    <>
                        <time className="article-view-date" dateTime={article.date}>{formatDate(new Date(article.date))}</time>
                        <h1 className="content-title">{article.title}</h1>
                        {article.imageUrl && <img src={article.imageUrl} alt="" className="article-view-image"/>}
                        <div className="prose" dangerouslySetInnerHTML={{__html: article.content ?? ''}}/>
                    </>
                ) : (
                    <div aria-hidden="true">
                        {Array.from({length: 8}, (_, i) => <div key={i} className="skeleton skeleton-line"/>)}
                    </div>
                )}
            </article>
        </div>
    );
};

export default ArticleView;
